<template>
  <b-row class="mt-3">
    <template v-if="programms.length">
      <b-col>
        <b-row>
          <b-col>
            <h3 class="mt-4">{{ $t('PAGE_home_my_programms') }}</h3>
            <List :programms="programms_active" :loading="loading" />
          </b-col>
        </b-row>

        <b-row v-if="programms_arcived.length && programms_active.length">
          <b-col>
            <template>
              <b-button
                variant="link"
                class="text-muted w-100"
                @click="showArchivedState = !showArchived"
                >{{
                  showArchived
                    ? $t('PROGRAMMSLIST_hide_archived')
                    : $t('PROGRAMMSLIST_show_archived')
                }}</b-button
              >
            </template>
          </b-col>
        </b-row>
        <b-row v-if="showArchived">
          <b-col>
            <List :programms="programms_arcived" :loading="loading" />
          </b-col>
        </b-row>
      </b-col>
    </template>
    <template v-else>
      <b-col class="my-5">
        <template v-if="advertisment.status === 'loading'">
          <b-row>
            <b-col cols="12" md="5">
              <LoadingLine width="90%" height="100%" />
            </b-col>
            <b-col cols="12" md="7">
              <LoadingLine width="90%" />
              <LoadingLine width="40%" />
              <LoadingLine width="30%" />
              <LoadingLine width="50%" class="mt-4" />
              <LoadingLine width="40%" />
              <b-row class="mt-4">
                <b-col class="d-flex align-items-center">
                  <LoadingLine width="70%" height="20px" />
                </b-col>
                <b-col>
                  <LoadingLine width="50%" height="30px" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
        <template v-if="advertisment.status === 'pending'">
          <b-row>
            <b-col cols="12" md="5">
              <img src="../../assets/advertisment_pending.svg" />
            </b-col>
            <b-col class="d-flex align-items-center">
              <div>
                <b-row class="mt-2">
                  <b-col>
                    <p
                      v-html="
                        $t(
                          'COMPONENT_programmlist_participate_in_group_therapies_pending_body',
                          { physioName: advertisment.physioName }
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col>
                    <p
                      class="text-muted"
                      v-html="
                        $t(
                          'COMPONENT_programmlist_participate_in_group_therapies_pending_body_extra'
                        )
                      "
                    />
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </template>
        <template v-if="advertisment.status === 'noVideos'">
          <b-row>
            <b-col cols="12" md="5">
              <img src="../../assets/advertisment_accepted.svg" />
            </b-col>
            <b-col class="d-flex align-items-center">
              <div>
                <b-row class="mt-2">
                  <b-col>
                    <p
                      v-html="
                        $t(
                          'COMPONENT_programmlist_participate_in_group_therapies_accepted_body',
                          { physioName: advertisment.physioName }
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col>
                    <p
                      class="text-muted"
                      v-html="
                        $t(
                          'COMPONENT_programmlist_participate_in_group_therapies_pending_accepted_extra'
                        )
                      "
                    />
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </template>
        <template v-if="advertisment.status === 'noRequest'">
          <b-row>
            <b-col cols="12" md="5">
              <img src="../../assets/advertisment_group.svg" />
            </b-col>
            <b-col class="d-flex align-items-center">
              <feature name="physio" variant="soft_marketing">
                <b-row>
                  <b-col>
                    <span
                      class="text-disabled small"
                      v-t="
                        'COMPONENT_programmlist_soft_marketing_participate_in_group_therapies_title_pre'
                      "
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b
                      v-t="
                        'COMPONENT_programmlist_soft_marketing_participate_in_group_therapies_title'
                      "
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <p
                      v-t="
                        'COMPONENT_programmlist_soft_marketing_participate_in_group_therapies_body'
                      "
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="d-flex align-items-center">
                    <a :href="therapygroupHref" class="small">
                      <i class="fa fa-external-link mr-2" />
                      {{
                        $t(
                          'COMPONENT_programmlist_participate_in_group_therapies_more'
                        )
                      }}
                    </a>
                  </b-col>
                </b-row>
              </feature>
              <feature name="physio" variant="marketing">
                <b-row>
                  <b-col>
                    <b-badge variant="physio" pill>Premium</b-badge>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col>
                    <b
                      v-t="
                        'COMPONENT_programmlist_participate_in_group_therapies_title'
                      "
                    />
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col>
                    <p
                      v-html="
                        $t(
                          'COMPONENT_programmlist_participate_in_group_therapies_body'
                        )
                      "
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="d-flex align-items-center">
                    <a :href="therapygroupHref" class="small">
                      <i class="fa fa-external-link mr-2" />
                      {{
                        $t(
                          'COMPONENT_programmlist_participate_in_group_therapies_more'
                        )
                      }}
                    </a>
                  </b-col>
                  <b-col>
                    <b-button
                      size="sm"
                      variant="outline-grey"
                      :to="{ name: 'profile_index', params: { tabIndex: 3 } }"
                    >
                      <span
                        class="small"
                        v-t="
                          'COMPONENT_programmlist_participate_in_group_therapies_go_to_profile'
                        "
                      />
                    </b-button>
                  </b-col>
                </b-row>
              </feature>
            </b-col>
          </b-row>
        </template>
      </b-col>
    </template>
  </b-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { first, escape, pathOr } from 'lodash/fp';
import LoadingLine from '@/elements/LoadingLine';
import List from './List';

export default {
  name: 'ProgrammsList',
  asyncData({ store, route }) {
    return Promise.all([
      store.dispatch('getProgramms'),
      store.dispatch('loadPhysioRequests'),
    ]);
  },
  data() {
    return {
      showArchivedState: false,
    };
  },
  computed: {
    ...mapState(['language']),
    ...mapState({
      loading: state => state.api.pending.programms,
      loadingPhysioRequests: state => state.api.pending.physioRequests,
      physiosRequests: state => state.api.physioRequests,
    }),
    ...mapGetters(['programms']),
    therapygroupHref() {
      if (this.language === 'fr')
        return 'https://bechterew.ch/fr/groupes-de-therapie/';
      if (this.language === 'en')
        return 'https://bechterew.ch/fr/groupes-de-therapie/';
      return 'https://bechterew.ch/therapiegruppen/';
    },
    showArchived() {
      return (
        this.showArchivedState ||
        (!this.programms_active.length && this.programms_arcived.length)
      );
    },
    programms_active() {
      return this.programms.filter(p => !p.archived);
    },
    programms_arcived() {
      return this.programms.filter(p => p.archived);
    },
    advertisment() {
      const recentRequest = first(this.physiosRequests);
      const getStatus = request => {
        if (!request && this.loadingPhysioRequests) return 'loading';
        if (!request) return 'noRequest';
        if (!request.accepted && !request.rejected) return 'pending';
        if (request.accepted && !request.rejected) return 'noVideos';

        return null;
      };

      return {
        physioName: escape(pathOr('', 'physio.name', recentRequest)),
        status: getStatus(recentRequest),
      };
    },
  },
  components: { List, LoadingLine },
};
</script>



// WEBPACK FOOTER //
// src/components/ProgrammsList/index.vue